import { denominatorDataId, numeratorDataId } from './utils'

export interface CharacterCountProps {
  value: string
  maxChars: number
}

export const CharacterCount = (props: CharacterCountProps) => {
  const { value, maxChars } = props
  const numChars = value.length

  const ariaText = `${numChars} out of ${maxChars} characters`

  return (
    <span aria-live="polite" role="status" aria-atomic="true" title={ariaText}>
      <span aria-hidden="true">
        <span data-classname={numeratorDataId}>{numChars}</span>/
        <span data-classname={denominatorDataId}>{`${maxChars} characters`}</span>
      </span>
    </span>
  )
}
